<template>
<div class="detail-price">

  <vue-headful
    title="TZ Design Box - Detail Price"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'price-logs'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("price-details") }}</h2>
          <p>{{ $t("price-details-details") }}</p>
          <table class="table">
          <thead>
            <tr>
                <th>{{ $t("type") }}</th>
                <th>{{ $t("article-number") }}</th>
                <th>{{ $t("quantity") }}</th>
                <th>{{ $t("width") }}</th>
                <th>{{ $t("height") }}</th>
                <th>{{ $t("depth") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("price-article") }}</th>
                <th>{{ $t("price") }}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="price in getDetailPrice" :key="price.num">
                    <td style="font-size:12px;">{{price.type}}</td>
                    <td style="font-size:12px;">{{price.item_number}}</td>
                    <td style="font-size:12px;">{{price.quantity}}</td>
                    <td style="font-size:12px;">{{price.width}}</td>
                    <td style="font-size:12px;">{{price.height}}</td>
                    <td style="font-size:12px;">{{price.depth}}</td>
                    <td style="font-size:12px;">{{price.discount}}</td>
                    <td style="font-size:12px;">{{price.item_price}} <span v-if="price.oprice != price.item_price">({{ price.oprice }})</span></td>
                    <td style="font-size:12px;">{{price.price}}</td>
                </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'

export default {
    name: 'DetailPrice',
    props: ["pid"],
    computed: { ...mapGetters
        (["getCurrentCompany","getDetailPrice"])
    },
    data: function () {
        return{}
    },
    components: { MenuVert, Breadcrumbs},
    created () {
        let self = this
        this.$store.dispatch ("callDetailPrice",{self: self, pid: this.pid})
    }
}
</script>

<style>
.detail-price{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
